import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setSummaryDetails , reportDWH } from '../../EnergyReplaceBlockSlice';
import { createEnergyReplaceAsync } from '../../EnergyReplaceBlockAsyncThunk';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { validateField, validateForm } from '../../../../../utilities/validation/formValidation';
import ThirdParty from '../../../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';

const SendAgreementPage = (props) => {
    const [sendAgreementType, setSendAgreementType] = useState('');//sms|email
    const [sendAgreementError, setSendAgreementError] = useState('');

    const [formData, setFormData] = useState({
        email: { value: props.subscriber.primaryEmail, error: '', validationRules: { required: true, requiredMessage: 'נא הזן דואר אלקטרוני', regexName: 'emailRegex', regexMessage: 'דואר אלקטרוני לא תקין' } },
        isConfirmTerms: { value: false, error: '', validationRules: { required: true, requiredMessage: 'אנא אשר את תנאי השימוש' } },
        isReceivingAd: { value: false, error: '', validationRules: { required: false, requiredMessage: '' } },
    });

    useEffect(() => {
        console.info('props.programDetailsLink', props.programDetailsLink);
        console.info('props.connectionAgreementLink', props.connectionAgreementLink);
        console.info('props.termsLink', props.termsLink);
    }, []);

    return (
        <div className='send-agreement-page'>

            <div className='page-title'> כמעט וסיימנו </div>
            <div className='page-sub-title'> לאן לשלוח את ההסכם החדש? </div>

            <div className='radio-list-wrapper'>

                <div className='radio-item'>
                    <input type='radio' id={`radio-item-sms`} name='send-type' onChange={() => handleOnTypeClick('sms')} />
                    <label htmlFor={`radio-item-sms`}>
                        <div className='radio-icon'></div>
                        <div className='details'> SMS למספר {props.contactNumber} </div>
                    </label>
                </div>

                <div className='radio-item'>
                    <input type='radio' id={`radio-item-email`} name='send-type' onChange={() => handleOnTypeClick('email')} />
                    <label htmlFor={`radio-item-email`}>
                        <div className='radio-icon'></div>
                        <div className='details'> למייל </div>
                    </label>
                </div>

            </div>

            <div className='field-wrapper'>
                <TextInput
                    value={formData.email.value}
                    error={formData.email.error}
                    placeholder='כתובת מייל'
                    id='email'
                    name='email'
                    type='email'
                    disabled=''
                    required='required'
                    maxLength='40'
                    autoComplete="off"
                    onChange={(e) => handleOnChange('email', e.target.value)}
                />
            </div>

            {
                props.bottomText &&
                <div className='text-wrapper' dangerouslySetInnerHTML={{ __html: props.bottomText }}></div>
            }

            <div className='checkboxs-wrapper'>
                <div className='checkbox-item'>
                    <CheckBox
                        checked={formData.isConfirmTerms.value}
                        label={<> קראתי ואני מסכים <a href='#' onClick={() => buildUrlAndOpenWindow(props.programDetailsLink)}>לעיקרי פרטי התכנית</a>, <a href='#' onClick={() => buildUrlAndOpenWindow(props.connectionAgreementLink)}>להסכם ההתקשרות</a> <a href='#' onClick={() => buildUrlAndOpenWindow(props.termsLink)}>ולתנאים הכלליים</a> </>}
                        id='isConfirmTerms'
                        error={formData.isConfirmTerms.error}
                        onCheck={() => onCheck('isConfirmTerms')}
                        onUncheck={() => onUncheck('isConfirmTerms')}
                    />
                </div>
                {
                  !props.subscriber.collaborationApproval &&
                  <div className='checkbox-item'>
                      <CheckBox
                          checked={formData.isReceivingAd.value}
                          label= {<ThirdParty />}
                          id='isReceivingAd'
                          error={formData.isReceivingAd.error}
                          onCheck={() => onCheck('isReceivingAd')}
                          onUncheck={() => onUncheck('isReceivingAd')}
                      />
                  </div>
                }
            </div>

            <div className='button-wrapper'>
                {sendAgreementError && <div className='error-not-selected'>{sendAgreementError}</div>}
                <BtnSubmit text={'אישור'} onclick={handleOnContinue} formid='send-agreement-page' />
            </div>

        </div>
    );

    function handleOnChange(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
    }

    function onCheck(checkboxName) {
        formData[checkboxName].value = true;
        formData[checkboxName].error = '';
        setFormData({ ...formData });
    }

    function onUncheck(checkboxName) {
        let errorMessage = '';
        if (checkboxName == 'isConfirmTerms'){
            errorMessage = 'אנא אשר את תנאי השימוש';
        }
        formData[checkboxName].value = false;
        formData[checkboxName].error = errorMessage;
        setFormData({ ...formData });
    }

    function handleOnTypeClick(type) {
        setSendAgreementType(type);
        setSendAgreementError('');
        props.reportDWH({
            actionType: 'SelectAgreementDeliveryMethod',
            status: 'Ongoing',
            messageText: type === 'sms' ? 'SelectAgreementDeliveryMethodSmsDisplay' : 'SelectAgreementDeliveryMethodEmailDisplay',
        });
    }

    function handleOnContinue() {
      let isValid = true;

        if (!sendAgreementType) {
            setSendAgreementError('יש לבחור לאן לשלוח את ההסכם החדש');
            isValid = false;
        }

        if (sendAgreementType == 'email') {
            const error = validateField(formData.email.validationRules, formData.email.value);
            if (error) {
                formData.email.error = error;
                setFormData({ ...formData });
                isValid = false;
            }
        }

        if(!formData.isConfirmTerms.value) {
            formData.isConfirmTerms.error = 'אנא אשר את תנאי השימוש';
            setFormData({ ...formData });
            isValid = false;
        }

        if(!isValid) {
          return;
        }

        const summaryDetails = {
            summaryWillBeSentTo: sendAgreementType,
            summarySmsNumber: props.contactNumber,
            summaryEmail: formData.email.value,
            isConfirmTerms: formData.isConfirmTerms.value,
            isReceivingAd: formData.isReceivingAd.value
        }
        props.setSummaryDetails(summaryDetails);
        props.createEnergyReplaceAsync();
    }

};

const mapStateToProps = (state) => {
    return {
        programDetailsLink: state.energyReplaceBlock.selectedPackage?.programDetailsLink,
        connectionAgreementLink: state.energyReplaceBlock.selectedPackage?.connectionAgreementLink,
        termsLink: state.energyReplaceBlock.selectedPackage?.termsLink,
        subscriber: state.energyReplaceBlock.subscriber,
        contactNumber: state.authentication.loginData?.userDetails?.contactNumber,
        bottomText: state.energyReplaceBlock.bottomText
    };
};

const mapDispatchToProps = {
    setSummaryDetails,
    createEnergyReplaceAsync,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SendAgreementPage);
